import React from "react"
import DynamicImage from "../common/DynamicImage"

const StatsSection = ({ data }) => {
    return (
        <>
            <section className="funfacts-area">
                <div className="container">
                    <div className="row gy-3">
                        {data.statsItem?.map((card) => (
                            <div className="col-lg-3 col-sm-6 col-6" key={card.id}>
                                <div className="single-funfacts-item">
                                    {card.image?.url && (
                                        <div className="icon">
                                            <DynamicImage image={card.image} />
                                        </div>
                                    )}
                                    {card.title && <h3>{card.title}</h3>}
                                    {card.description && <p>{card.description}</p>}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

export default StatsSection
